import React from 'react';
import { motion } from 'framer-motion';

const BackgroundAccents = ({ primaryColor = "bg-blue-100", secondaryColor = "bg-orange-50", opacity = "opacity-20" }) => (
    <div className={`fixed inset-0 pointer-events-none overflow-hidden z-0 ${opacity}`}>
        <motion.div
            className={`absolute top-[-10%] left-[-10%] w-[40%] h-[40%] ${primaryColor} rounded-full blur-[120px]`}
            animate={{
                x: [0, 50, 0],
                y: [0, 30, 0],
            }}
            transition={{
                duration: 20,
                repeat: Infinity,
                ease: "linear"
            }}
        />
        <motion.div
            className={`absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] ${secondaryColor} rounded-full blur-[120px]`}
            animate={{
                x: [0, -50, 0],
                y: [0, -30, 0],
            }}
            transition={{
                duration: 25,
                repeat: Infinity,
                ease: "linear"
            }}
        />
        {/* Minimalist Grid Lines */}
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #000 0.5px, transparent 0.5px)', backgroundSize: '40px 40px', opacity: 0.1 }}></div>
    </div>
);

export default BackgroundAccents;
